export default [
  {text: '', value: '÷'},
  {text: '', value: '√'},
  {text: '', value: '±'},
  {text: '', value: '≈'},
  {text: '', value: '≠'},
  {text: '', value: '≥'},
  {text: '', value: '≤'},
  {text: '', value: '∽'},
  {text: '', value: '≌'},
  {text: '', value: '∥'},
  {text: '', value: '⊥'},
  {text: '', value: 'β'},
  {text: '', value: 'α'},
  {text: '', value: 'γ'},
  {text: '', value: 'θ'},
  {text: '', value: 'Δ'},
  {text: '', value: 'Λ'},
  {text: '', value: 'Ξ'},
  {text: '', value: 'Ο'},
  {text: '', value: 'Σ'},
  {text: '', value: 'Φ'},
  {text: '', value: 'Ψ'},
  {text: '', value: 'Ω'},
  {text: '', value: 'π'},
  {text: '', value: '∠'},
  {text: '', value: '∝'},
  {text: '', value: '∞'},
  {text: '', value: '◦'},
  {text: '', value: '∪'},
  {text: '', value: '∫'},
  {text: '', value: '∮'},
  {text: '', value: '◊'},
];